import Vue from 'vue'
import Vuex from 'vuex'
import sidebar from './modules/sidebar'
import login from './modules/login'
import app from './modules/app'
import websocket from './modules/websocket'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        sidebar,
        login,
        app,
        websocket,
    }
})